import { useState, useEffect } from 'react'
import _ from 'lodash'
import { Separator, Grid, Input, Tooltip } from '@design-systems/canvas-ui'
import { AutocompleteInput } from '../../common/AutocompleteInput'
import Icon, { InfoIcon } from '@design-systems/react-icons'
import {
  buildDropdownOptions,
  getReactionGridDataField,
  fetchGroupName,
  getDropdownOptions,
} from '../../common/helper'
import { renderRFI3QuestionWindow } from '../../common/rfiHelper'
import ReactionGrid from '../../common/ReactionGrid'
import { SectionWrapper, renderControl } from '../Builders'
import FactoryInput from './FactoryInputSelector'
import { getRfiTagValues } from '../../common/common'
import { RFI_TYPE_SUPPLIER } from '../../common/commonConstants'

const BF_SECTION_NAME = 'beauty_formulation_capabilities'
const controlGroups = [
  {
    uid: 'factory_capabilities',
    group: 'OTC / Flammable / Pressurized Capability ',
    controls: [
      {
        uid: 'exp_proof_cosmetics',
        type: 'radio_button_group',
        options: 'common.yes_no_na',
        label_name: 'Explosion Proof Cosmetics',
        row: 1,
        column: 1,
        width: 3,
        width_percentage: 100,
      },
      {
        uid: 'alcohol_capability',
        type: 'radio_button_group',
        options: 'common.yes_no_na',
        label_name: 'Alcohol Capability',
        row: 1,
        column: 2,
        width: 3,
        width_percentage: 100,
      },
      {
        uid: 'aerosol_capability',
        type: 'radio_button_group',
        options: 'common.yes_no_na',
        label_name: 'Aerosol Capability',
        row: 1,
        column: 3,
        width: 3,
        width_percentage: 100,
      },
    ],
  },
  {
    uid: 'factory_capabilities',
    group: 'FDA Regulated Capabilities',
    controls: [
      {
        uid: 'otc_drugs',
        type: 'radio_button_group',
        options: 'common.yes_no_na',
        label_name: 'OTC Drugs',
        row: 2,
        column: 1,
        width: 3,
        width_percentage: 100,
      },
      {
        uid: 'dietary_supplements',
        type: 'radio_button_group',
        options: 'common.yes_no_na',
        label_name: 'Dietary Supplements',
        row: 2,
        column: 2,
        width: 3,
        width_percentage: 100,
      },
      {
        uid: 'medical_devices',
        type: 'radio_button_group',
        options: 'common.yes_no_na',
        label_name: 'Medical Devices',
        row: 2,
        column: 3,
        width: 3,
        width_percentage: 100,
      },
      {
        uid: 'cosmetics',
        type: 'radio_button_group',
        options: 'common.yes_no_na',
        label_name: 'Cosmetics',
        row: 2,
        column: 4,
        width: 3,
        width_percentage: 100,
      },
    ],
  },
  {
    uid: 'testing',
    controls: [
      {
        uid: 'testing',
        type: 'reaction_grid',
        options: 'beauty_formulation_capabilities',
        label_name: 'Testing',
        row: 1,
        column: 1,
        width: 7,
        width_percentage: 100,
        info: getRfiTagValues('rfi1InfoIconMessages')[BF_SECTION_NAME][
          'testing'
        ],
      },
    ],
  },
  {
    uid: 'research_and_development',
    controls: [
      {
        uid: 'research_and_development',
        type: 'reaction_grid',
        options: 'beauty_formulation_capabilities',
        label_name: 'Research & Development',
        row: 1,
        column: 1,
        width: 10,
        width_percentage: 100,
        info: getRfiTagValues('rfi1InfoIconMessages')[BF_SECTION_NAME][
          'research_and_development'
        ],
      },
    ],
  },
]

const controlGroupsForReadOnly = [
  {
    uid: 'factory_capabilities',
    group: 'OTC / Flammable / Pressurized Capability ',
    controls: [
      {
        uid: 'exp_proof_cosmetics',
        type: 'label_readonly_header',
        label_name: 'Explosion Proof Cosmetics',
        row: 1,
        column: 1,
        width: 3,
        width_percentage: 100,
      },
      {
        uid: 'alcohol_capability',
        type: 'label_readonly_header',
        label_name: 'Alcohol Capability',
        row: 1,
        column: 2,
        width: 3,
        width_percentage: 100,
      },
      {
        uid: 'aerosol_capability',
        type: 'label_readonly_header',
        label_name: 'Aerosol Capability',
        row: 1,
        column: 3,
        width: 3,
        width_percentage: 100,
      },
    ],
  },
  {
    uid: 'factory_capabilities',
    group: 'FDA Regulated Capabilities',
    controls: [
      {
        uid: 'otc_drugs',
        type: 'label_readonly_header',
        label_name: 'OTC Drugs',
        row: 2,
        column: 1,
        width: 3,
        width_percentage: 100,
      },
      {
        uid: 'dietary_supplements',
        type: 'label_readonly_header',
        label_name: 'Dietary Supplements',
        row: 2,
        column: 2,
        width: 3,
        width_percentage: 100,
      },
      {
        uid: 'medical_devices',
        type: 'label_readonly_header',
        label_name: 'Medical Devices',
        row: 2,
        column: 3,
        width: 3,
        width_percentage: 100,
      },
      {
        uid: 'cosmetics',
        type: 'label_readonly_header',
        label_name: 'Cosmetics',
        row: 2,
        column: 4,
        width: 3,
        width_percentage: 100,
      },
    ],
  },
  {
    uid: 'testing',
    controls: [
      {
        uid: 'testing',
        type: 'reaction_grid',
        options: 'beauty_formulation_capabilities',
        label_name: 'Testing',
        row: 1,
        column: 1,
        width: 7,
        width_percentage: 100,
        info: getRfiTagValues('rfi1InfoIconMessages')[BF_SECTION_NAME][
          'testing'
        ],
      },
    ],
  },
  {
    uid: 'research_and_development',
    controls: [
      {
        uid: 'research_and_development',
        type: 'reaction_grid',
        options: 'beauty_formulation_capabilities',
        label_name: 'Research & Development',
        row: 1,
        column: 1,
        width: 10,
        width_percentage: 100,
        info: getRfiTagValues('rfi1InfoIconMessages')[BF_SECTION_NAME][
          'research_and_development'
        ],
      },
    ],
  },
]

const BeautyFormulationCapabilities = (props) => {
  const SECTION_CUST_FORM = 'custom_formulation'
  const SECTION_PROD_CLAIMS = 'product_claims'
  const FIXED_REACTION_GRIDS = ['research_and_development', 'testing']
  const SECTION_RSCH_AND_DEV = 'research_and_development'
  const SECTION_TESTING = 'testing'
  const SECTION_OWNED_FACTORIES = 'owned_factories'
  const SECTION_FACTORY_CAPABILITIES = 'factory_capabilities'

  const [beautyFormulationCapabilities, setBeautyFormulationCapabilities] =
    useState(props.sectionData)

  //Trigger save
  const [isTriggerSave, setIsTriggerSave] = useState(false)

  useEffect(() => {
    if (
      isTriggerSave &&
      !_.isEqual(props.sectionData, beautyFormulationCapabilities)
    ) {
      props.saveRfiPayload(
        beautyFormulationCapabilities,
        props.sectionTemplate.uid,
      )
    }
  }, [isTriggerSave]) // eslint-disable-line react-hooks/exhaustive-deps

  const updateSelectedBeautyFormulationData = (propertyId, selectedRGs) => {
    let groupRDList = []
    selectedRGs.forEach((eachSelectedRG) => {
      let foundRGDetails = beautyFormulationCapabilities[propertyId].filter(
        (eachExistingRG) =>
          eachExistingRG.display_name === eachSelectedRG.value,
      )
      if (foundRGDetails.length) {
        groupRDList.push(foundRGDetails[0])
      } else {
        let masterGroupId =
          props.rfiMasterData?.common.beauty_formulation_capabilities[
            propertyId
          ].filter(
            (eachMasterRG) =>
              eachMasterRG.display_name === eachSelectedRG.value,
          )[0]?.group_name
        groupRDList.push({
          group_name: masterGroupId,
          display_name: eachSelectedRG.value,
          capabilities: [],
        })
      }
    })

    setBeautyFormulationCapabilities({
      ...beautyFormulationCapabilities,
      [propertyId]: groupRDList,
    })
  }

  /**
   * Dynamically generate entire section reaction grids in reference to the autocomplete input box match
   *
   * @param {*} section name of the section to generate
   * @returns reaction grid for the section
   */
  const createSectionReactionGrids = (section) => {
    return beautyFormulationCapabilities[section]
      ?.map((e) => e.display_name)
      .map((item, index) => {
        let group = fetchGroupName(
          props.rfiMasterData?.common,
          BF_SECTION_NAME,
          section,
          item,
        )
        return (
          <Grid.Item
            size={{ xs: 8 }}
            id={`grid-rg-${section}-${item}`}
            key={`grid-rg-${section}-${item}`}
            className="hc8-pt-2x"
          >
            <ReactionGrid
              id={`rg-${section}-${index}-${item}`}
              heading={getReactionGridDataField(
                props.rfiMasterData?.common?.beauty_formulation_capabilities,
                beautyFormulationCapabilities,
                section,
                group,
                'display_name',
                props.isReadonly,
              )}
              info={
                getRfiTagValues('rfi1InfoIconMessages')[BF_SECTION_NAME][
                  [group]
                ]
              }
              fields={getReactionGridDataField(
                props.rfiMasterData?.common?.beauty_formulation_capabilities,
                beautyFormulationCapabilities,
                section,
                fetchGroupName(
                  props.rfiMasterData?.common,
                  BF_SECTION_NAME,
                  section,
                  item,
                ),
                'rows',
                props.isReadonly,
              )}
              options={getReactionGridDataField(
                props.rfiMasterData?.common?.beauty_formulation_capabilities,
                beautyFormulationCapabilities,
                section,
                fetchGroupName(
                  props.rfiMasterData?.common,
                  BF_SECTION_NAME,
                  section,
                  item,
                ),
                'title',
                props.isReadonly,
              )}
              value={
                beautyFormulationCapabilities[section].filter(
                  (groups) => groups.display_name === item,
                )[0]?.capabilities
              }
              section={section}
              isreadOnly={props.isReadonly}
              groupName={fetchGroupName(
                props.rfiMasterData?.common,
                BF_SECTION_NAME,
                section,
                item,
              )}
              updateGridValues={props.isReadonly ? () => {} : updateGridValues}
              removeGrid={props.isReadonly ? () => {} : removeGrid}
              allowRemove={!props.isReadonly}
            ></ReactionGrid>
            <Separator className="hc8-pt-6x" />
          </Grid.Item>
        )
      })
  }

  /**
   * To Remove Reaction Grid based on table selection
   * @param {*} heading
   * @param {*} groupUID
   * @param {*} sectionUID
   */
  const removeGrid = (heading, groupUID, sectionUID) => {
    let newRGSet = beautyFormulationCapabilities[sectionUID]
      .filter((e) => e.group_name !== groupUID)
      .map((e) => e)

    setBeautyFormulationCapabilities({
      ...beautyFormulationCapabilities,
      [sectionUID]: newRGSet,
    })
  }

  const updateGridValues = (groupName, displayName, section, valueMatrix) => {
    const newData = beautyFormulationCapabilities[section].map(
      (eachGrid, gridIndex) => {
        return eachGrid.group_name !== groupName
          ? eachGrid
          : { ...eachGrid, capabilities: valueMatrix }
      },
    )
    setBeautyFormulationCapabilities({
      ...beautyFormulationCapabilities,
      [section]: newData,
    })
  }

  /**
   * To update DOM for template based rendering, also carry out based on the control name and also handle
   * reaction grid value matrix rendering for template based controls.
   * @param {*} property name of the property to update
   * @param {*} value value of the control to update
   * @param {*} section name of the section to update
   * @param {*} valueMatrix for which the reaction grid value matrix should be updated
   */
  const onInputChangeHandler = (value, metadata) => {
    let groupUID = metadata?.inputMetadata?.groupUID
    switch (groupUID) {
      case SECTION_OWNED_FACTORIES:
        setBeautyFormulationCapabilities({
          ...beautyFormulationCapabilities,
          [SECTION_OWNED_FACTORIES]: value,
        })
        break
      case SECTION_RSCH_AND_DEV: {
        let newData = [
          {
            group_name: metadata.groupName,
            display_name: metadata.displayName,
            capabilities: value,
          },
        ]

        setBeautyFormulationCapabilities({
          ...beautyFormulationCapabilities,
          [SECTION_RSCH_AND_DEV]: newData,
        })
        break
      }
      case SECTION_TESTING: {
        let newData = [
          {
            group_name: metadata.groupName,
            display_name: metadata.displayName,
            capabilities: value,
          },
        ]

        setBeautyFormulationCapabilities({
          ...beautyFormulationCapabilities,
          [SECTION_TESTING]: newData,
        })
        break
      }
      default:
        setBeautyFormulationCapabilities({
          ...beautyFormulationCapabilities,
          [groupUID]: {
            ...beautyFormulationCapabilities[groupUID],
            [metadata.uid]: value,
          },
        })
    }
  }

  /**
   * To drive template based rendering on the body
   * @param {*} section name of the section for rendering
   * @returns rendered controls of the screen
   */
  const renderBFCTemplateControls = (groupUID) => {
    const controlGroupsForComputation = props.isReadonly
      ? controlGroupsForReadOnly
      : controlGroups
    return controlGroupsForComputation
      ?.filter((controlGroup) => controlGroup.uid === groupUID)
      ?.map((controlGroup) => {
        let groupControls = controlGroup.controls?.map((eachControl) => {
          let mutatedRowControl = Object.assign({}, eachControl)
          let controlMetadata = {}
          controlMetadata.groupUID = groupUID
          controlMetadata.isreadOnly = props.isReadonly
          mutatedRowControl.metadata = controlMetadata

          let masterData = FIXED_REACTION_GRIDS.includes(groupUID)
            ? props.rfiMasterData.common
            : props.rfiMasterData

          let controlData = FIXED_REACTION_GRIDS.includes(groupUID)
            ? beautyFormulationCapabilities[groupUID]?.[0]
            : beautyFormulationCapabilities[groupUID]

          return (
            <Grid.Item size={{ xs: eachControl.width }}>
              {renderControl(
                mutatedRowControl,
                controlData,
                masterData,
                props.isReadonly ? () => {} : onInputChangeHandler,
              )}
            </Grid.Item>
          )
        })

        return (
          <div>
            {controlGroup.group && (
              <Input.Label className="hc8-fs-150 hc8-mt-none font-weight-500">
                {controlGroup.group}
              </Input.Label>
            )}
            <Grid.Container className="hc8-mt-1x hc8-mb-1x">
              {groupControls}
            </Grid.Container>
          </div>
        )
      })
  }

  const renderBeautyFormulationBody = () => {
    let sectionContent = (
      <Grid.Container>
        {/* 1. Custom Formulation */}
        <Grid.Item size={{ xs: 12 }}>
          <div className="align-centre-left hc8-mt-4x">
            <Input.Label className="hc8-fs-150 hc8-mb-none font-weight-500">
              Custom Formulation
            </Input.Label>
            <Tooltip
              className="hc8-ml-2x"
              content={
                getRfiTagValues('rfi1InfoIconMessages')[BF_SECTION_NAME][
                  'selectCapabilitiesBelow'
                ]
              }
              location="right"
            >
              <Icon className="row-centre" svg={InfoIcon} />
            </Tooltip>
          </div>

          <Input.Label className="hc8-mt-4x hc8-fs-100 hc8-mb-4x">
            Select All Formulation Category
          </Input.Label>
          <Grid.Item size={{ xs: 4 }}>
            <AutocompleteInput
              value={buildDropdownOptions(
                beautyFormulationCapabilities[SECTION_CUST_FORM]?.map(
                  (e) => e.display_name,
                ),
                null,
                false,
                false,
              )}
              multiselect={true}
              class="hc8-fs-150"
              options={getDropdownOptions(
                SECTION_CUST_FORM,
                props.rfiMasterData.common,
                BF_SECTION_NAME,
              )}
              readOnly={props.isReadonly}
              onUpdate={(value) => {
                updateSelectedBeautyFormulationData(SECTION_CUST_FORM, value)
              }}
            />
          </Grid.Item>
          <Grid.Item className={props.isReadonly ? 'hc8-pt-2x' : 'hc8-pt-none'}>
            {createSectionReactionGrids(SECTION_CUST_FORM)}
          </Grid.Item>
        </Grid.Item>

        {/* 2. Product Claims */}
        <Grid.Item
          size={{ xs: 12 }}
          className={props.isReadonly ? 'hc8-pv-none' : ''}
        >
          <div className="align-centre-left hc8-mt-4x">
            <Input.Label className="hc8-fs-150 hc8-mb-none font-weight-500">
              Product Claims
            </Input.Label>
            <Tooltip
              className="hc8-ml-2x"
              content={
                getRfiTagValues('rfi1InfoIconMessages')[BF_SECTION_NAME][
                  'productClaimsInfoText'
                ]
              }
              location="right"
            >
              <Icon className="row-centre" svg={InfoIcon} />
            </Tooltip>
          </div>

          <Input.Label className="hc8-mt-4x hc8-fs-100 hc8-mb-4x">
            Select All Product Claims
          </Input.Label>
          <Grid.Item size={{ xs: 4 }}>
            <AutocompleteInput
              value={buildDropdownOptions(
                beautyFormulationCapabilities[SECTION_PROD_CLAIMS]?.map(
                  (e) => e.display_name,
                ),
                null,
                false,
                false,
              )}
              multiselect={true}
              class="hc8-fs-150"
              options={getDropdownOptions(
                SECTION_PROD_CLAIMS,
                props.rfiMasterData.common,
                BF_SECTION_NAME,
              )}
              onUpdate={(value) => {
                updateSelectedBeautyFormulationData(SECTION_PROD_CLAIMS, value)
              }}
              readOnly={props.isReadonly}
            />
          </Grid.Item>
          <Grid.Item className={props.isReadonly ? 'hc8-pt-2x' : 'hc8-pt-none'}>
            {createSectionReactionGrids(SECTION_PROD_CLAIMS)}
          </Grid.Item>
        </Grid.Item>

        {/* 3. Research & Development - reaction grid */}
        <Grid.Item
          size={{ xs: 12 }}
          className={props.isReadonly ? 'hc8-pv-none' : ''}
        >
          {beautyFormulationCapabilities.research_and_development &&
            renderBFCTemplateControls(SECTION_RSCH_AND_DEV)}
        </Grid.Item>

        {/* 4. Testing - reaction grid */}
        <Grid.Item
          size={{ xs: 12 }}
          className={
            props.isReadonly ? 'hc8-pb-none margin-top-m30' : 'hc8-pt-none'
          }
        >
          {beautyFormulationCapabilities.testing &&
            renderBFCTemplateControls(SECTION_TESTING)}
        </Grid.Item>

        {/* 5. Owned Factories */}
        {props.rfiType === RFI_TYPE_SUPPLIER && (
          <Grid.Item size={{ xs: 12 }} className="hc8-pv-none">
            <FactoryInput
              subSectionName={'Owned Factories'}
              factoryData={
                beautyFormulationCapabilities[SECTION_OWNED_FACTORIES]
              }
              groupUID={SECTION_OWNED_FACTORIES}
              rfiMasterData={props.rfiMasterData}
              updateFactoryData={onInputChangeHandler}
              isReadonly={props.isReadonly}
              errorCache={props.errorCache}
            />
          </Grid.Item>
        )}

        {/* 6. OTC / Flammable / Pressurized Capability & FDA Regulated Capabilities */}
        <Grid.Item size={{ xs: 12 }}>
          {beautyFormulationCapabilities.factory_capabilities &&
            renderBFCTemplateControls(SECTION_FACTORY_CAPABILITIES)}
        </Grid.Item>
      </Grid.Container>
    )

    return props.isRfi3
      ? renderRFI3QuestionWindow(
          props.isRfi3Readonly,
          sectionContent,
          beautyFormulationCapabilities?.rfi3_answers,
          props.sectionTemplate,
          props.rfiMasterData,
          (sectionRfi3Answers) =>
            setBeautyFormulationCapabilities({
              ...beautyFormulationCapabilities,
              rfi3_answers: sectionRfi3Answers,
            }),
          props.supplierId,
          props.locationId,
          props.manufacturingTypeId,
          props.sectionData?.rfi3_files,
          (sectionRfiFiles) => {
            setIsTriggerSave(true)
            setBeautyFormulationCapabilities({
              ...beautyFormulationCapabilities,
              rfi3_files: sectionRfiFiles,
            })
          },
          props.errorCache,
        )
      : sectionContent
  }

  return (
    <SectionWrapper
      sectionTemplate={props.sectionTemplate}
      sectionBody={renderBeautyFormulationBody()}
      setIsTriggerSave={
        !props.isReadonly || props.isRfi3 ? setIsTriggerSave : () => {}
      }
      isRfi3={props.isRfi3}
    />
  )
}

export default BeautyFormulationCapabilities
